module.exports = __webpack_public_path__ + "assets/img/home9.052d3a07.png";